module.exports = __webpack_public_path__ + "img/icon-room-master-bedroom.42806e97.svg";